// @ts-nocheck
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import LoadingOverlay, { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { DataViewCollectionResult, DataViewResult } from "@toolkit/Framework/Store/Data/DataState";
import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import { css } from "styled-components";

export interface DataViewLoadingOverlayProps extends LoadingOverlayProps {
    dataView?: DataViewResult | DataViewCollectionResult;
    loading?: boolean;
    loadComplete?: boolean;
    preload?: boolean;
}

export interface DataViewLoadingOverlayStyles {
    loadingOverlay?: LoadingOverlayProps;
}

export const dataViewLoadingOverlayStyles: DataViewLoadingOverlayStyles = {
    loadingOverlay: { minHeight: 150 },
};

const styles = dataViewLoadingOverlayStyles;

const DataViewLoadingOverlay: FC<DataViewLoadingOverlayProps> = ({
    children,
    dataView,
    loading,
    loadComplete,
    preload = true,
    css: baseCss,
    ...loadingOverlayProps
}) => {
    const { isEditing } = useShellContext();
    const isLoading = loading || dataView?.isLoading;
    const hasLoadComplete = typeof loadComplete === "boolean";

    const getIsInitialized = useCallback(() => {
        return hasLoadComplete
            ? loadComplete
            : Boolean(!loading && (!dataView || dataView.errorStatusCode || (dataView.value && !dataView.isLoading)));
    }, [hasLoadComplete, loadComplete, loading, dataView?.errorStatusCode, dataView?.value, dataView?.isLoading]);

    const [isInitialized, setIsInitialized] = useState(getIsInitialized());

    useEffect(() => {
        if (!isInitialized) {
            setIsInitialized(getIsInitialized());
        }
    }, [getIsInitialized]);

    const loadingOverlayCss = useMemo(() => {
        return css`
            ${styles.loadingOverlay?.css}
            ${baseCss}
        `;
    }, [baseCss]);

    if (typeof isLoading === "undefined" && !hasLoadComplete) {
        return <>{children}</>;
    }

    return (
        <LoadingOverlay
            loading={!isEditing && (isLoading || (preload && !isInitialized))}
            {...styles.loadingOverlay}
            {...loadingOverlayProps}
            css={loadingOverlayCss}
        >
            {(isEditing || isInitialized) && children}
        </LoadingOverlay>
    );
};

export default DataViewLoadingOverlay;
